import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { IconCloseCircle } from '../Icon/index';
import { StyledTagCloseButton } from './TagCloseButton.styles';

/**
 * A close button for `Tag` components.
 *
 * @since 8.25.0
 */
export var TagCloseButton = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledTagCloseButton, _extends({
    ref: forwardedRef
  }, props), /*#__PURE__*/React.createElement(IconCloseCircle, {
    size: "xs"
  }));
});
TagCloseButton.displayName = 'TagCloseButton';
TagCloseButton.propTypes = {
  /**
   * The spoken label when targeted by a screen reader.
   */
  'aria-label': PropTypes.string,
  /**
   * The button type, with default `"button"`.
   */
  'type': PropTypes.string
};
TagCloseButton.defaultProps = {
  'aria-label': 'Remove tag',
  'type': 'button'
};